import { defaultState } from './default-state';
import { ACTION_TYPES as types } from './action-types';

const reducer = ( state = defaultState, action ) => {
	let newState = state;
	switch ( action.type ) {
		case types.SET_PROCESSING_METHOD:
			newState = {
				...state,
				selectedProcessingId: action.selectedProcessingId,
			};
			break;
		case types.SET_CARRIER:
			newState = {
				...state,
				selectedCarrierId: action.selectedCarrierId,
			};
			break;
		case types.SET_DATE:
			newState = {
				...state,
				selectedSlot: '',
				selectedDate: action.selectedDate,
			};
			break;
		case types.SET_TIMESLOT:
			newState = {
				...state,
				selectedSlot: action.timeSlot.selectedSlot,
			};
			break;
		case types.INITIALIZED:

			newState = {
				...defaultState,
				selectedCarrierId: action.initialized.selectedCarrierId,
				selectedProcessingId: action.initialized.selectedProcessingId,
				selectedDate: action.initialized.selectedDate,
				selectedSlot: action.initialized.selectedSlot,
				isRequired: action.initialized.isRequired,
				allCarriers: action.initialized.allCarriers,
				allSlots: action.initialized.allSlots,
				allDates: action.initialized.allDates,
				initialized: action.initialized.initialized,
				currentRateId: action.initialized.currentRateId,
			};

			break;
		case types.SET_DATES:
			const dateInfo = action.allDates;
			newState = {
				...state,
				allSlots: dateInfo.allSlots,
				selectedCarrierId: dateInfo.selectedCarrierId,
				selectedDate: dateInfo.selectedDate,
				selectedSlot: dateInfo.selectedSlot,
				allDates: dateInfo.allDates,
			};
			break;
		case types.SET_TIMESLOTS:
			const slotInfo = action.allSlots;

			newState = {
				...state,
				allSlots: slotInfo.allSlots,
				selectedSlot: slotInfo.selectedSlot,
				selectedDate: slotInfo.selectedDate,
			};
			break;
		case types.UPDATING_DATES:{
			newState = {
				...state,
				isUpdate: action.isUpdate,
			};
		}
	}

	return newState;
};

export default reducer;
